package org.dronda.app.web

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.css.CSSColor
import com.varabyte.kobweb.compose.css.borderBottom
import com.varabyte.kobweb.compose.css.boxSizing
import com.varabyte.kobweb.compose.css.color
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.AnimationFillMode
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.StyleSheet
import org.jetbrains.compose.web.css.animation
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.duration
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.css.timingFunction
import org.jetbrains.compose.web.css.transform
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Div

@OptIn(ExperimentalComposeWebApi::class)
object LoaderStyles : StyleSheet() {
    val rotation by keyframes {
        from {
            transform {
                rotate(0.deg)
            }
        }
        to {
            transform {
                rotate(360.deg)
            }
        }
    }
    init {
        ".loader" {
            width(48.px)
            height(48.px)
            border {
                width(5.px)
                style = LineStyle.Solid
                this.color(Colors.White)
            }
            borderBottom {
                color(rgb(13, 0, 35))
            }
            display(DisplayStyle.InlineBlock)
            boxSizing(BoxSizing.BorderBox)
            borderRadius(50.percent)
            property("animation", "${rotation.name} 1s linear infinite")
//            animation(rotation) {
//                duration(1.s)
//                timingFunction(AnimationTimingFunction.Linear)
//            }
        }
        console.log(this.toString())
    }
}

@Composable
fun Loader(modifier: Modifier = Modifier) {
    Div(
        modifier.attrsModifier {
            classes("loader")
        }.toAttrs()
    )
}